<template>
  <BannerImages />
</template>

<script>
// @ is an alias to /src
import BannerImages from "@/components/BannerImages.vue";

export default {
  name: "BannerImageVIew",
  components: {
    BannerImages,
  },
};
</script>
